import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AuthLayout from './layouts/auth_layout/AuthLayout.tsx';
import MainLayout from './layouts/main_loayout/MainLayout.tsx';



function App() {
  return (
    <div >
     <Router>
        <Routes>
          <Route path="/*" element={<AuthLayout />} />
          <Route path="main/*" element={<MainLayout />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
